import React, {Component} from 'react';
import moment from 'moment'
import {Box} from 'reactjs-admin-lte'
import {Row,Col,Alert,ButtonToolbar,Button,DropdownButton,SplitButton,MenuItem,ControlLabel,FormControl,Popover,OverlayTrigger} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import Select from 'react-select'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import SlipEditPopup from './SlipEditPopup'
import HolidayPopup from './HolidayPopup'
import SlipConfigPopup from './SlipConfigPopup'
import EmployeeAbsenceTablePopup from '../absence/EmployeeAbsenceTablePopup'
import EmployeeDeductionTablePopup from '../deduction/EmployeeDeductionTablePopup'
import AlertPopup from '../../../component/element/AlertPopup'
import AlertPopupStore from '../../../component/element/AlertPopupStore'
import HrStore from '../../../stores/HrStore'

 


//import SlipExcelExporter from './SlipExcelExporter'
//http://adazzle.github.io/react-data-grid/examples.html#/sortable-cols
const API_MAIN = 'https://api.bigfix.co/demo2/';
const TOTAL_DAYS = 13
const NUMBER_FIELD = [5,6,7,8,9,10,11,12,13,14,15,16,17,18]
const EDIT_FIELD = [5,6,7,8,9,10,11,12]


const SLIP_INDEX = 0
const EM_ID_INDEX = 1

const COUNT_OFFICE_INDEX = 5
const WAGE_FIELD_INDEX = 6
const TOTAL_WAGE_INDEX = 7
const DRAWING_INDEX = 8
const OT_HOUR_INDEX = 9
const OT_WEEKEND_INDEX = 10
const OT_AMOUNT_AFTERWORK_INDEX = 11
const OT_AMOUNT_WEEKEND_INDEX = 12
const TOTAL_INCOME_INDEX = 13
const CUMULATIVE_DEPT_INDEX = 14
const SOCIAL_SECURITY_INDEX = 15
const ABSENCE_DEDECTION_INDEX = 16 
const TOTAL_DEDUCTION_INDEX = 17
const NET_INCOME_INDEX = 18
const PAYABLE_INDEX = 19

const DAILY_DISABLE_FIELDS = [TOTAL_WAGE_INDEX,TOTAL_INCOME_INDEX,NET_INCOME_INDEX]
const MONTHLY_DISABLE_FIELDS = [TOTAL_WAGE_INDEX,TOTAL_INCOME_INDEX,NET_INCOME_INDEX]
class SlipContractorTable extends Component {
  constructor(...args){
    super(...args)
    this.slipConfig = {}
    var dt = new Date();
    let month = dt.getMonth() + 1
    month = ('0000'+month).slice(-2)
    let year = (dt.getFullYear()*1+543)
    
    let options = this.getWeekDayOnMonth(year,month)
    let option  = this.getCurrentRange(options,dt);

    this.state = {show:false,showHoliday:false,showCfg:false,showAbsenceForm:false,showDeductionForm:false,editRow:'',loading:true,statusText:'',slipId:'',options:options,year:year,month:month,rangeValue:option,tableList:[]}

    
    this.refTableId  = 'slipEmpTable-'+Math.ceil(Math.random()*100);
    this.loadNetworkData(year,month,option)
    
    
  }

  loadNetworkData(year,month,option){
    let {emType} = this.props
    let loadConfig = function(that){
     let promise = new Promise(function (resolve, reject) {     
        HrStore.loadSlipConfig(function(result){
          that.slipConfig = result.data      
          console.log('slipConfig',that.slipConfig)
          resolve(that)
        },function(error){
          reject(error) 
        })
     })
     return promise
    }

    let loadAllSlipDailyWage = function(that){
      let promise = new Promise(function (resolve, reject) {
        that.loadAllSlipWage(emType,year,month,option,reject)
      })
      return promise
    }

    loadConfig(this)
    .then(loadAllSlipDailyWage)
    .catch(error=>{
      console.log('error:',error)
      this.setState({loading:false,statusText:error.desc})
    })
  }
  
  loadAllSlipWage(emType,year,month,option,reject){
    let that = this
    if(emType==='daily'){       
      HrStore.loadAllSlipDailyWage(year,month,option,function(result){
            that.setState({tableList:result.data,loading:false})
          },function(error){
            if(typeof reject!=='undefined')
              reject(error)            
          })
    }else{
      
      HrStore.loadAllSlipMonthlyWage(year,month,option,function(result){
            that.setState({tableList:result.data,loading:false})
          },function(error){
            if(typeof reject!=='undefined')
              reject(error)            
          })          
    }
  
  }

  getYearOptions(){
    let options = []
    var dt = new Date();
    for(let i=(dt.getFullYear()*1+543);i>=2558;i--){
      options.push({label:i,value:i})
    }
    return options;
  }



  onCreateSlipClick(){
    let that = this
    let {year,month,rangeValue,options,tableList} = this.state
    let {emType} = this.props

    let title = 'ต้องการจะออกสลิปสำหรับช่างเหมา?'
    if(tableList.length>0){
      title = 'ได้ออกสลิปแล้ว ต้องการเริ่มต้นออกสลิป ของเดิมที่แก้ไขไปแล้วจะถูกลบทิ้ง ยืนยันที่ดำเนินการต่อไปหรือไม่?'
    }
    AlertPopupStore.confirm(title,'ยืนยัน',function(){
      that.setState({loading:true})
      
        HrStore.newSlipContractor(year,month,rangeValue,options,function(result){
          that.setState({loading:false,tableList:result.data})
        },function(error){
          console.log('error',error)
        })
     
    })

  }

  onYearChange(e){
    let year = e.value,{month,rangeValue} = this.state, that = this
    let {emType} = this.props
    that.setState({year:year,loading:true,options:this.getWeekDayOnMonth(year,month)})

    this.loadAllSlipWage(emType,year,month,rangeValue)
    
  }

  onMonthChange(e){
    let month = e.value,{year,rangeValue} = this.state, that = this
    let {emType} = this.props
    this.setState({month:month,loading:true,options:this.getWeekDayOnMonth(year,month)})
    this.loadAllSlipWage(emType,year,month,rangeValue)
    
  }

  onRangeChange(e){
    let {year,month} = this.state, that = this
    let {emType} = this.props
    let rangeValue = e

    this.setState({rangeValue:rangeValue,loading:true})
    this.loadAllSlipWage(emType,year,month,rangeValue)

  }

  onRowClick(slipId){
    console.log('onRowClick',slipId)
    this.refs.slipEditPopup.loadSlipInfo(slipId);
    this.setState({show:true,slipId:slipId})
  }

  onColumnClick(row,col,colValue){
    console.log('row',row,col)
    let {emType} = this.props
    let {tableList,rangeValue,year,month} = this.state
    let disableFields = []
    disableFields = DAILY_DISABLE_FIELDS
    if(emType==='monthly'){      
      disableFields = []
      disableFields = disableFields.concat(MONTHLY_DISABLE_FIELDS)   
      if(rangeValue.seqInMonth==='secondhalf')
        disableFields.push(DRAWING_INDEX);   
    }

    if(EDIT_FIELD.includes(col) && !disableFields.includes(col)){
      let value = (typeof colValue.value !=='undefined')?colValue.value:colValue      
      tableList[row][col] = {value:value}

      this.setState({tableList:tableList})
    }else if(col===SLIP_INDEX){      
      let slipId = tableList[row][0]
      this.refs.slipEditPopup.loadSlipInfo(slipId);
      this.setState({show:true,slipId:slipId,editRow:row})
    }else if(col===EM_ID_INDEX){      
      let emId = tableList[row][1]
      this.onEmployeeIdClick(emId)     
    }else if(col===SOCIAL_SECURITY_INDEX){
            

      //this.refs.deductionPopup.loadDeduction(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      //this.setState({showDeductionForm:true,editRow:row})
    }else if(col===ABSENCE_DEDECTION_INDEX){
            

      // this.refs.absencePopup.loadAbsence(tableList[row][EM_ID_INDEX],rangeValue.startDate,rangeValue.endDate,this.getRangeText())
      // this.setState({showAbsenceForm:true,editRow:row})
    }
  }

  getMonthOptions(){
    return [{label:'มกราคม',value:'01'},{label:'กุมภาพันธ์',value:'02'},
            {label:'มีนาคม',value:'03'},{label:'เมษายน',value:'04'},
            {label:'พฤษภาคม',value:'05'},{label:'มิถุนายน',value:'06'},
            {label:'กรกฎาคม',value:'07'},{label:'สิงหาคม',value:'08'},
            {label:'กันยายน',value:'09'},{label:'ตุลาคม',value:'10'},
            {label:'พฤศจิกายน',value:'11'},{label:'ธันวาคม',value:'12'},
          ]
  }

  getCountOfWorkOptions2(){
    let options = []
    for(let i=10;i<31;i++){
      options.push({label:i+' วัน',value:i})
    }
    return options;
  }

  getMonthText(month){
    let result=''
    this.getMonthOptions().map((item,index)=>{

      if(item.value===month){
        result = item.label
      }
      return item
    })
    return result
  }

  getWeekDay(year,month,day){
    let myDate = new Date();
    myDate.setFullYear(year-543);
    myDate.setMonth((month*1)-1);
    myDate.setDate(day);
    return myDate.getDay()
  }

  getRangeOption(year,month,start,end,monthText,seqInMonth){
    let between = start+'-'+end
    let startDate = (year-543)+'/'+((start>20)?(month*1-1):month)+'/'+start
    let endDate   = (year-543)+'/'+month+'/'+end
    
    let countOfDays = moment(endDate, "YYYY/MM/DD").diff(moment(startDate, "YYYY/MM/DD"), 'days')+1  
    return {label:start+' - '+end+' '+monthText,value:between,startDate:startDate,endDate:endDate,countOfWork:countOfDays,seqInMonth:seqInMonth}
  }

  getWeekDayOnMonth(year,month){
    let monthText = this.getMonthText(month)
    let options = []

    let wkDay1 = this.getWeekDay(year,month*1-1,28);
    let wkDay2 = this.getWeekDay(year,month,13);
    let wkDay3 = this.getWeekDay(year,month,28);

    if(wkDay1===0 && wkDay2===0 && wkDay3===0){
      options = [this.getRangeOption(year,month,30,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,29,monthText,'secondhalf')]
    }else if(wkDay1===0 && wkDay2===0 ){
      options = [this.getRangeOption(year,month,30,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,28,monthText,'secondhalf')]      
    }else if(wkDay1===0 && wkDay3===0 ){
      options = [this.getRangeOption(year,month,30,13,monthText,'firsthalf'),this.getRangeOption(year,month,14,29,monthText,'secondhalf')]      
    }else if(wkDay2===0 && wkDay3===0 ){
      options = [this.getRangeOption(year,month,29,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,29,monthText,'secondhalf')]      
    }else{
      options = [this.getRangeOption(year,month,29,13,monthText,'firsthalf'),this.getRangeOption(year,month,14,28,monthText,'secondhalf')]      
    }
    console.log('getDay',wkDay1,wkDay2,wkDay3,year,month)
    //if(myDate.getDay() == 6 || myDate.getDay() == 0) alert('Weekend!');
    return options;
  }

  getCurrentRange(options,date){
    let compareDate = moment(date)
    //let compareDate = moment('2017/05/29','YYYY/MM/DD')
    let option = null
    options.map((item,index)=>{
      let startDate = moment(item.startDate, "YYYY/MM/DD")
      let endDate = moment(item.endDate, "YYYY/MM/DD")  
      //console.log('compare',compareDate,startDate,endDate)    
      //console.log('item',item,compareDate.toString(),startDate.toString(),endDate.toString())
      if(compareDate.isSameOrAfter(startDate) && compareDate.isSameOrBefore(endDate)){
        //console.log('Yes')
        option = item
      }
      return item
    })   

    if(option===null){
      option = options[0]
    } 

    return option
  }

  getRangeText(){
    let {rangeValue,year} = this.state
    let betweenTitle = rangeValue.label + ' ' + year
    return betweenTitle
  }

  getCountOfWorkOptions(){
    let {year,month} = this.state
    return this.getWeekDayOnMonth(year,month)
  }

  calculateIncome(row){
    console.log('cal',row)
    let {emType} = this.props
    if(emType==='daily'){
      row[TOTAL_WAGE_INDEX] = row[COUNT_OFFICE_INDEX] * row[WAGE_FIELD_INDEX]
      row[OT_AMOUNT_AFTERWORK_INDEX]  = Math.round((row[WAGE_FIELD_INDEX]/8) * row[OT_HOUR_INDEX] * this.slipConfig['OT_AFTERWORK_FOR_DAILY'])
      row[OT_AMOUNT_WEEKEND_INDEX]    = Math.round((row[WAGE_FIELD_INDEX]) * row[OT_WEEKEND_INDEX] * this.slipConfig['OT_HOLIDAY_FOR_DAILY'])
    }else{
      row[OT_AMOUNT_AFTERWORK_INDEX]  = Math.round((row[WAGE_FIELD_INDEX]/30/8) * row[OT_HOUR_INDEX] * this.slipConfig['OT_AFTERWORK_FOR_MONTHLY'])
      row[OT_AMOUNT_WEEKEND_INDEX]    = Math.round((row[WAGE_FIELD_INDEX]/30) * row[OT_WEEKEND_INDEX] * this.slipConfig['OT_HOLIDAY_FOR_MONTHLY'])      
      
    }
    row[TOTAL_INCOME_INDEX]  = row[DRAWING_INDEX]*1 + row[OT_AMOUNT_AFTERWORK_INDEX]*1 + row[OT_AMOUNT_WEEKEND_INDEX]*1
    row[NET_INCOME_INDEX] = row[TOTAL_INCOME_INDEX]*1 - row[TOTAL_DEDUCTION_INDEX]*1

    if(emType==='monthly'){
      //row[PAYABLE_INDEX] = row[WAGE_FIELD_INDEX]*1 - row[DRAWING_INDEX]*1;
    }    

    return row
  }

  validateValue(tableList,row,col,value){
    let {emType} = this.props
    if(emType==='monthly'){
      if(col===DRAWING_INDEX){
        let salary = tableList[row][WAGE_FIELD_INDEX]
        if(value>(salary)/2){
          //Alert
          AlertPopupStore.confirm("เงินเบิก "+value+" เกินครึ่งหนึ่งของเงินเดือน "+salary,'กลับไปแก้ข้อมูล',function(){
          
          })
          return false
        }      
      }
    }
    return true
  }

  onInputBlur(row,col,colValue){
    console.log('onBlur',colValue)
    let {tableList,year,month,rangeValue}  = this.state

    if(!this.validateValue(tableList,row,col,colValue.value)){
      return;
    }
    tableList[row][col] = colValue.value
    tableList[row] = this.calculateIncome(tableList[row])
    this.setState({tableList:tableList,loading:true})
    console.log('tableList',tableList)
    let param = {em:tableList[row][EM_ID_INDEX],periodic:HrStore.getPeriodic(year,month,rangeValue.value)}
    if(col===OT_HOUR_INDEX){      
      param = Object.assign(param,{field:'ot_hour',ot_type:0,ot_hour:tableList[row][col],ot_amount:tableList[row][OT_AMOUNT_AFTERWORK_INDEX]})
    }else if(col===OT_WEEKEND_INDEX){      
      param = Object.assign(param,{field:'ot_hour',ot_type:2,ot_hour:tableList[row][col],ot_amount:tableList[row][OT_AMOUNT_WEEKEND_INDEX]})
    }else if(col===WAGE_FIELD_INDEX){
      param = Object.assign(param,{field:'wage_hour',end_date:rangeValue.endDate,count_office_work:tableList[row][COUNT_OFFICE_INDEX],wage_amount:tableList[row][col]})
    }else if(col===DRAWING_INDEX){
      param = Object.assign(param,{field:'salary',drawing_money:tableList[row][DRAWING_INDEX],
      total_income:tableList[row][TOTAL_INCOME_INDEX],net_payable:tableList[row][PAYABLE_INDEX],net_income:tableList[row][NET_INCOME_INDEX]})
    }    

    let that = this
    HrStore.editSlipDailyWage(param,function(){
      that.setState({loading:false})
    },function(error){
      console.log('error',error);
      that.setState({loading:false,statusText:error.desc.response.data})
    })

  }

  

  onInputChange(row,col,e){
    let value = e.target.value
    let {tableList,year,month}  = this.state
    tableList[row][col] = e.target.value
    tableList[row] = this.calculateIncome(tableList[row])
    tableList[row][col] = {value:e.target.value}    
    this.setState({tableList:tableList})


  }

  

  onEmployeeIdClick(emId){
    if (process.env.NODE_ENV == "development") {
      alert('click->'+emId)
    }else{
      window.show_employee_doc(emId);
    }
  }

  onSlipPrintClick(slipId){

    if (process.env.NODE_ENV == "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?ss=' + slipId + '&file=salaryslip_doc', '_blank');
    }else{
        window.open('./pdf/?ss=' + slipId + '&file=salaryslip_doc', '_blank');
    }
  }

  onSlipPrintAllClick(){
    
    let {year,month,rangeValue} = this.state
    let {emType} = this.props
    let emId = (emType==='monthly')?1:2;
    let periodic = HrStore.getPeriodic(year,month,rangeValue.value)
    if (process.env.NODE_ENV == "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?periodic=' + periodic + '&file=allslip_doc&em_type='+emId, '_blank');
    }else{
        window.open('./pdf/?periodic=' + periodic + '&file=allslip_doc&em_type='+emId, '_blank');
    }
  }

  onSlipPrintTableClick(){
    let {year,month,rangeValue} = this.state
    let periodic = HrStore.getPeriodic(year,month,rangeValue.value)
    let {emType} = this.props
    let emId = (emType==='monthly')?1:2;
    
    let param = '&start_date='+rangeValue.startDate+'&end_date='+rangeValue.endDate

    if (process.env.NODE_ENV == "development") {
        window.open('https://demo2.bigfix.co/korat/pdf/?periodic=' + periodic + '&file=sliptable_doc&em_type='+emId+param, '_blank');
    }else{
        window.open('./pdf/?periodic=' + periodic + '&file=sliptable_doc&em_type='+emId+param, '_blank');
    }
  }

  onSlipExportExcellClick(){
    // let {year,month} = this.state
    // var d = new Date(year, month*1, 0);
    // var day = d.getDate();
    // let periodic = day+'/'+month+'/'+year;

    // var url = API_MAIN + "/employee/allslip_dailywage?format=excel&periodic=" + periodic;
    // window.open(url, '_blank');

    
    
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    // let wb = new Workbook()
    // wb.SheetNames.push('worksheet')
    // wb.Sheets['worksheet'] = worksheet
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), "Report.xlsx")
  
  }

  onEditPopup(){
    this.setState({show:false,editRow:''})
    let {emType} = this.props
    let {year,month,rangeValue} = this.state, that = this

    this.loadAllSlipWage(emType,year,month,rangeValue)
  }

  onEnter(row,col){
    //Test
  }

  onMenuSelect(eventKey){
    
    if(eventKey===2){
      this.setState({showHoliday:true})
      this.refs.holidayPopup.loadHoliday()
    }else if(eventKey===1){
      this.setState({showCfg:true})
      this.refs.slipCfgPopup.loadConfig()
    }
  }

  onHolidayClick(){
    this.setState({showHoliday:true})
  }


  onAbsenceClose(changeFlag){
    let {emType} = this.props
    let {editRow,tableList,rangeValue,year,month} = this.state
    this.setState({showAbsenceForm:false,loading:changeFlag})

    //Update Deduction
    
    if(changeFlag){
      let param = {field:'absence',em:tableList[editRow][EM_ID_INDEX],
      start_date:rangeValue.startDate,end_date:rangeValue.endDate,
      periodic:HrStore.getPeriodic(year,month,rangeValue.value)}
      

      let that = this
      HrStore.editSlipDailyWage(param,function(){
        that.setState({loading:false})
        //that.loadAllSlipWage(emType,year,month,rangeValue)
      },function(error){
        console.log('error',error);
        that.setState({loading:false,statusText:error.desc.response.data})
      })
    }
  }

  onSlipChange(){

  }

  onDeductionClose(changeFlag){
    this.setState({showDeductionForm:false,editRow:'',loading:changeFlag})
  }

  onSlipEditAbsenceClose(changeFlag){
    this.onAbsenceClose(changeFlag)
  }

  onSlipEditAbsence(loadAbsence){
      let {tableList,rangeValue,editRow,periodState} = this.state
      //let {rangeValue,options,year,month} = periodState
      console.log('editRow',editRow)

      loadAbsence(tableList[editRow][EM_ID_INDEX],rangeValue,this.getRangeText())
  }

  

  renderOverlayContent(item){
    return (
      <Popover id="popover-trigger-hover-focus" title="รายละเอียด">
          <strong><FontAwesome name='info'/>{' '}สามารถแก้ไขได้</strong>
      </Popover>
    )
  }

  renderEditColumn(item,rowIndex,index){
    if(index===SLIP_INDEX || index===EM_ID_INDEX){
      return (<a>{item}</a>)
    }
    if(item!==null && item!=='' && typeof item.value !=='undefined')
      return (<input autoFocus
        style={{width:'80px',display:'inline-block'}}
        className='form-control text-right'
        value={item.value}
        onBlur={ this.onInputBlur.bind(this,rowIndex,index,item) }
        onChange={ this.onInputChange.bind(this,rowIndex,index) }
      />)

    if(EDIT_FIELD.includes(index)){
      return (
        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom"
          onEnter={this.onEnter.bind(this,rowIndex,index)} overlay={this.renderOverlayContent(item)}>
            <div>{item}</div>
        </OverlayTrigger>)
    }
    return (<div className={index===TOTAL_INCOME_INDEX?'text-green':(index===NET_INCOME_INDEX)?'text-red':''}>{item}</div>)
  }

  renderColumn(coldata,rowIndex){
    let {emType} = this.props
    let {rangeValue} = this.state
    let disableFields = DAILY_DISABLE_FIELDS
    if(emType==='monthly'){
      disableFields = []
      disableFields = disableFields.concat(MONTHLY_DISABLE_FIELDS)
      if(rangeValue.seqInMonth==='secondhalf'){
        disableFields.push(DRAWING_INDEX)
      }
    }
    return coldata.map((item,index)=>(
      <td key={index}
        
        className={(NUMBER_FIELD.includes(index)?'text-right':'')+(disableFields.includes(index)?' disabled':'')}
        onClick={this.onColumnClick.bind(this,rowIndex,index,item)}>
        {this.renderEditColumn(item,rowIndex,index)}
      </td>
    ))
  }

  renderButtonColumn(item){
    return (<td className='text-center no-padding'>
      <Button bsStyle='link' onClick={this.onSlipEditClick.bind(this,item[0])}><FontAwesome name='pencil'/></Button>
      <Button bsStyle='link' onClick={this.onSlipPrintClick.bind(this,item[0])}><FontAwesome name='print'/></Button>
      <Button bsStyle='link'><FontAwesome name='user-o'/></Button>
    </td>)
  }

  renderHeader(){
    let {emType} = this.props
    return (
      <tr role="row">
                    <th>ชื่อ-นามสกุล</th>
                    <th>ชื่อเล่น</th>
                    <th>แผนก/ฝ่าย</th>
                    <th>ค่าแรง </th>                    
                    <th>ค่าแรงเหมาที่เหลือ</th>                    
                  </tr>
    )
  }

  renderTableList(){
    let {tableList} = this.state
    if(tableList.length>0){
      return tableList.map((item,index)=>(
        <tr key={index} >
          {this.renderColumn(item,index)}

        </tr>
      ))
    }else{
      return (<tr><td colSpan={23}>ยังไม่พบข้อมูล</td></tr>)
    }
  }

  renderFooter(){
    let {tableList} = this.state
    let {emType} = this.props
    let sumList = []
    if(tableList.length>0)
      sumList = new Array(tableList[0].length).fill(0)
    
    tableList.map((item,index)=>{   
      item.map((iitem,iindex)=>{
        sumList[iindex] = sumList[iindex] + (iitem*1)
      })         
      return item
    })
    let startIndex = 2
    

    let title = 'รวมค่าแรงเหมา'
    return (
      <tr role="row" >                    
                    <th colSpan={startIndex+1} className='text-center'>{title}</th>
                    <th className='text-right'>{sumList[++startIndex]}</th>                    
                    <th className='text-right'>{sumList[++startIndex]}</th>
                    <th className='text-right'>{sumList[++startIndex]}</th>

                  </tr>
    )
  }

  
  renderToolbarLeft(){
    let {month,year,rangeValue,options} = this.state
    return (
      <div className="navbar-form navbar-left">
          <div style={{width:'80px',display:'inline-block'}}>
            <Select value={year} options={this.getYearOptions()} onChange={this.onYearChange.bind(this)}  clearable={false}/>
          </div>
          <div style={{width:'180px',display:'inline-block'}}>
            <Select
              clearable={false}
              value={month}
              options={this.getMonthOptions()}
              onChange={this.onMonthChange.bind(this)}
              />
          </div>
          <div style={{width:'180px',display:'inline-block'}}>
            <Select
              placeholder='เลือกช่วงสัปดาห์'
              clearable={false}
              value={(rangeValue!==null)?rangeValue.value:''}
              options={options}
              onChange={this.onRangeChange.bind(this)}
              />
          </div>
          <div style={{width:'640px',display:'inline-block',marginLeft:'20px'}}>
            <ButtonToolbar>
              <Button bsStyle='primary' onClick={this.onCreateSlipClick.bind(this)}><FontAwesome name='table'/>{' '}สร้างตาราง</Button>
              <Button bsStyle={null} className='bg-maroon' onClick={this.onSlipPrintAllClick.bind(this)}><FontAwesome name='print'/>{' '}พิมพ์สลิปทั้งหมด</Button>
              <Button bsStyle={null} className='bg-maroon' onClick={this.onSlipPrintTableClick.bind(this)}><FontAwesome name='print'/>{' '}พิมพ์ตาราง</Button>
              <Button bsStyle={null} className='bg-green' onClick={this.onSlipExportExcellClick.bind(this)}><FontAwesome name='file-excel-o'/>{' '}ออกไฟล์Excel</Button>
            </ButtonToolbar>           
          </div>
      </div>
    )
  }

  renderToolbarRight(){
    return (
      <div className="box-tools pull-right">
        <ButtonToolbar>
          <DropdownButton bsStyle={'link'} title={'ตั้งค่า'} pullRight className='text-large' onSelect={this.onMenuSelect.bind(this)}>
            <MenuItem eventKey={1}><FontAwesome name='calendar-plus-o'/>&nbsp;ตัวคูณ OT</MenuItem>
            <MenuItem eventKey={2}><FontAwesome name='calendar-plus-o'/>&nbsp;วันหยุด</MenuItem>
          </DropdownButton>
        </ButtonToolbar>
      </div>
    )
  }

  renderStatusText(){
    let {statusText} = this.state
    if(statusText!==''){
      return (
        <Alert bsStyle="warning" onDismiss={()=>{this.setState({statusText:''})}}>
            <strong>เกิดข้อผิดพลาด!</strong> <div dangerouslySetInnerHTML={{__html: statusText}} />
            <div className="box-tools " style={{height:'30px'}}>
              <ButtonToolbar className='pull-right'>
                <Button bsStyle="default" onClick={()=>{this.setState({statusText:''})}}>ปิดข้อความ</Button>
              </ButtonToolbar>
            </div>
        </Alert>
      )
    }else{
      return (<div/>)
    }
  }

  renderTable(){
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-input-border-none table-bordered-solid table-hover dataTable' style={{minWidth:'1500px'}}>
        <thead>
          {this.renderHeader()}
        </thead>
        <tbody>
          {this.renderTableList()}
        </tbody>
        <tfoot>                  
            {this.renderFooter()}                  
        </tfoot>
      </table>
      </div>
    )
  }

  render(){
    let {slipId,editRow,show,showHoliday,showCfg,showAbsenceForm,showDeductionForm,loading,options} = this.state
    let {emType} = this.props
    let boxTitle = 'ตารางการจ่ายเงินช่างเหมา'
    return (      
        <Box loading={loading}>
          <Box.Header>
            <Box.Title>
              <FontAwesome name='history' className='text-blue'/>&nbsp;{boxTitle} ประจำวันที่ {this.getRangeText()}
            </Box.Title>
            <Box.Tools>
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            <Row>              
              {this.renderToolbarLeft()}              
            </Row>
            <Row>
            <Col md='12'>
              {this.renderStatusText()}
              {this.renderTable()}
            </Col>
            </Row>
            <SlipEditPopup ref='slipEditPopup' show={show} slipId={slipId}              
            onEditAbsence={this.onSlipEditAbsence.bind(this)}           
            onCloseAbsence={this.onSlipEditAbsenceClose.bind(this)}
            onHide={this.onEditPopup.bind(this)}/>
            <HolidayPopup ref='holidayPopup' show={showHoliday} onHide={()=>{this.setState({showHoliday:false})}}/>
            <SlipConfigPopup ref='slipCfgPopup' show={showCfg} onHide={()=>{this.setState({showCfg:false})}}/> 
            <EmployeeAbsenceTablePopup ref='absencePopup' show={showAbsenceForm} onHide={this.onAbsenceClose.bind(this)}/> 
            <EmployeeDeductionTablePopup ref='deductionPopup' show={showDeductionForm} onHide={this.onDeductionClose.bind(this)}/>
            <AlertPopup />   
          </Box.Body>
          <Box.Footer>
            <div className=" pull-right"></div>
          </Box.Footer>
        </Box>      
    )
  }
}

export default SlipContractorTable






// WEBPACK FOOTER //
// ./src/view/hr/slip/SlipContractorTable.js